import {BaseModel, Ordine} from './_Index';
import {Spedizione} from "./Spedizione";

export class Evento extends BaseModel {
  organizzazioneId?: number;
  dataRegistrazione: Date;
  dataUnixRegistrazione?: number;
  tipoEvento: number; // TODO convertilo in enum
  idDocumento: number;
  idRiga: number;
  idRigaLavorazione: number;
  risorsaId: number;
  codiceRisorsa?: string;
  statoRisorsa: number;
  ordine?: Ordine;
  spedizione?: Spedizione;
  executedBy?: string;
  actorUserId?: number;
  actorUserName?: string;
  actorDisplayName?: string;
  subjectUserId?: number;
  subjectUserName?: string;
  subjectDisplayName?: string;
  codiceArticolo?: string;  
  contesto?: number;
  note?: string;
  idDocImportazione?: number;
  idMovimento?: number;
  causaleId?: number;
  rifEsterno?: string;
  rifErp?: string;
}

